import 'scss/solutions/conference-solution.scss'
import 'babel-polyfill'
import 'js/libs/utils-solutions'
$(function () {
  $('.banner-buy-btn').click(function () {
    var top = $('.solutions-item-show').offset().top - 80
    $('html,body').animate({scrollTop: Math.floor(top)}, 500)
  })
})



// WEBPACK FOOTER //
// ./src/js/entry/solutions/conference-solution.js